(function () {
  const waitForButton = () => {
    const isMobile = window.innerWidth <= 768;

    const originalButton = document.getElementById('customily-preview-button');
    const dock = document.querySelector('mobile-dock');
    const stickyForm = document.querySelector('product-sticky-form');

    if (!originalButton || !stickyForm) {
      setTimeout(waitForButton, 500);
      return;
    }

    let dockButton, stickyButton, dockWrapper;

    const cloneButton = () => {
      const cleanClone = originalButton.cloneNode(true);
      cleanClone.addEventListener('click', () => originalButton.click());
      cleanClone.style.margin = '0';
      cleanClone.style.width = '100%';
      cleanClone.style.maxWidth = '480px';
      return cleanClone;
    };

    const insertDockButton = () => {
      dockButton = cloneButton();
      dockButton.id = 'customily-preview-button-fixed';

      const bottomValue = dock ? '64px' : '0';

      dockWrapper = document.createElement('div');
      dockWrapper.className = 'customily-fixed-preview-wrapper';
      dockWrapper.style.cssText = `
        position: fixed;
        bottom: ${bottomValue};
        left: 0;
        width: 100vw;
        z-index: 25;
        padding: 12px 16px;
        background: white;
        box-shadow: 0 -4px 12px rgba(0,0,0,0.06);
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        transform: translateY(100%);
        opacity: 0;
        transition: transform 80ms ease-out, opacity 80ms ease-out;
        will-change: transform, opacity;
        pointer-events: none;
      `;

      dockWrapper.appendChild(dockButton);
      document.body.appendChild(dockWrapper);
    };

    const insertStickyButton = () => {
      stickyButton = cloneButton();
      stickyButton.id = 'customily-preview-button-sticky';
      stickyButton.style.transform = 'scale(0.75)';
      stickyButton.style.transformOrigin = 'right center';

      const stickySubmit = stickyForm?.querySelector('button[type="submit"]');
      if (stickySubmit) stickySubmit.replaceWith(stickyButton);
    };

    const isVisible = el => {
      const rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom <= window.innerHeight;
    };

    const checkVisibility = () => {
      const stickyCard = stickyForm?.querySelector('.product-sticky-form__card');
      const stickyVisible = stickyCard &&
        getComputedStyle(stickyCard).visibility === 'visible' &&
        stickyCard.offsetParent !== null;

      const dockVisible = dock && isVisible(dock) && getComputedStyle(dock).visibility !== 'hidden';

      if (isMobile) {
        if (!dock) {
          if (stickyVisible) {
            dockWrapper.style.transform = 'translateY(100%)';
            dockWrapper.style.opacity = '0';
            dockWrapper.style.pointerEvents = 'none';
          } else {
            dockWrapper.style.transform = 'translateY(0)';
            dockWrapper.style.opacity = '1';
            dockWrapper.style.pointerEvents = 'auto';
          }
          return;
        }

        if (stickyVisible) {
          dockWrapper.style.transform = 'translateY(100%)';
          dockWrapper.style.opacity = '0';
          dockWrapper.style.pointerEvents = 'none';
        } else if (dockVisible) {
          dockWrapper.style.transform = 'translateY(0)';
          dockWrapper.style.opacity = '1';
          dockWrapper.style.pointerEvents = 'auto';
        } else {
          dockWrapper.style.transform = 'translateY(100%)';
          dockWrapper.style.opacity = '0';
          dockWrapper.style.pointerEvents = 'none';
        }
      }
    };

    const monitorLoadingStatus = () => {
      const observer = new MutationObserver(() => {
        if (!originalButton.classList.contains('running')) {
          observer.disconnect();
          dockButton?.classList.remove('running');
          stickyButton?.classList.remove('running');
          dockButton?.querySelector('.btn-loader')?.remove();
          stickyButton?.querySelector('.btn-loader')?.remove();
        }
      });

      observer.observe(originalButton, {
        attributes: true,
        attributeFilter: ['class'],
      });
    };

    if (isMobile) insertDockButton();
    insertStickyButton();
    monitorLoadingStatus();

    if (isMobile) {
      setInterval(checkVisibility, 200);
    }
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    waitForButton();
  } else {
    document.addEventListener('DOMContentLoaded', waitForButton);
  }
})();